<template>
    <div>
        <div>
            <validation-observer ref="AddTemplateForm" #default="{ invalid }">
                <b-form @submit.prevent="formSubmitted">
                    <b-row>
                        <b-col md="12">
                            <b-form-group label="Template Name" label-for="mc-Template-name">
                                <validation-provider #default="{ errors }" name="Name" vid="Name" rules="required">
                                    <b-form-input id="mc-Template-name" placeholder="Template Name"
                                        v-model="template.name" disabled/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group label="Platform Type" label-for="platform-type">
                                <validation-provider rules="required" #default="{ errors }" name="Platform Type" vid="Platform Type">
                                    <v-select
                                        v-model="template.platformType"
                                        :options="platformTypes"
                                        label="text"
                                        multiple
                                        :clearable="false"
                                        class="item-selector-title"
                                        placeholder="Select Platform Type"
                                        :state="errors.length > 0 ? false : null" disabled
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        
                        <b-col cols="12" class="mb-2">
                            <b-form-group label="Subject" label-for="textarea-default">
                                <validation-provider #default="{ errors }" name="Subject" vid="Subject" >
                                    <b-form-input id="textarea-default" type="text" placeholder="Subject"
                                        v-model="template.subject"  disabled/>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" class="mb-2">
                            <span>Template Content</span>
                            <quill-editor 
                                v-model="template.body"
                                :options="editorOption"
                                ref="quillEditor"
                                :disabled="true"
                            />
                        </b-col>
                        <b-col cols="12" class="mb-2">
                            <div v-if="previewMedia.length" class="preview-container">
                                <h5>Media Files:</h5>
                                <b-row>
                                    <b-col v-for="(media, index) in previewMedia" :key="index" cols="4" class="mb-2">
                                        <b-card class="preview-card">
                                            <!-- Display Image if MediaType is 'photos' -->
                                            <b-img 
                                                v-if="media.type === 'photos'"
                                                :src="media.src" 
                                                class="preview-media"
                                                alt="Preview Image"
                                            />
                        
                                            <!-- Display Video if MediaType is 'videos' -->
                                            <video 
                                                v-else-if="media.type === 'videos'"
                                                class="preview-media"
                                                controls
                                            >
                                                <source :src="media.src" type="video/webm" />
                                                Your browser does not support the video tag.
                                            </video>
                        
                                            <!-- <p class="text-center mt-1">{{ media.name }}</p> -->
                                            <b-button variant="success" size="sm" class="mt-1 w-100" @click="previewImageSelected(media.src)">
                                                Preview
                                            </b-button>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>                        
                    </b-row>
                </b-form>
            </validation-observer>
        </div>
         <!-- Full Image Preview Modal -->
         <b-modal v-model="showImageModal" hide-footer hide-header centered size="lg">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="ml-2">Image Preview</h5>
                <b-button variant="danger" @click="showImageModal = false" class="mr-2">Close</b-button>
            </div>
            <b-img :src="selectedImage" class="full-image" />
        </b-modal>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BFormGroup,
    BForm,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormCheckbox,
    BFormFile,
    BContainer,
    BCard,
    BCardText,
    BSpinner,
    BImg
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mapActions, mapGetters } from "vuex";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { quillEditor } from "vue-quill-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VSelect from "vue-select";
export default {
    components: {
        BFormSelect,
        BFormFile,
        BFormGroup,
        BForm,
        BFormTextarea,
        BFormInput,
        FormWizard,
        BContainer,
        BButton,
        BFormCheckbox,
        BCard,
        TabContent,
        BRow,
        BCol,
        ToastificationContent,
        BCardText,
        BSpinner,
        quillEditor,
        ValidationProvider,
        ValidationObserver,
        BImg,
        VSelect
    },
    data() {
        return {
            template: {
                name: null,
                platformType: [],
                subject: null,
                body: null,
                isActive: true,
                mediaFiles: []
            },
            previewImages: [],
            platformTypes: [
            ],
            showImageModal: false, // Controls modal visibility
        selectedImage: "", // Holds the image source for preview
            previewMedia: [],
            editorOption: {
    modules: {
        toolbar: false, // Removes toolbar completely
    },
    readOnly: true, // Ensures it's non-editable
},
            acceptFileTypes: "image/*, video/*",
        };
    },
    methods: {
        ...mapActions("emailtemplate", ["updateEmailTemplateAction", "getContentTemplateByIdAction", "getPlatformTypeAction"]),
        async formSubmitted() {
            // Start the loader
            let loader = this.$swal({
                title: 'Processing...',
                text: 'Please wait while the template is being added',
                onOpen: () => {
                    this.$swal.showLoading();
                },
                allowOutsideClick: () => !this.$swal.isLoading(),
                buttonsStyling: false,
                showConfirmButton: false,
            });

            try {
            let payload = {
                id: this.$route.params.id,
                name: this.template.name,
                platformTypeID: this.template.platformType.map(pt => pt.value),
                subject: this.template.subject,
                content: this.template.body,
                mediaDetails:  this.template.mediaFiles.map(file => ({
                name: file.file.name,
                extension: file.file.name.split('.').pop(),
                data: file.src, 
                user: 'Current User',
                description: file.name || 'Uploaded file'
            })),
                description : "",
                mediaPaths: [],
                contentType: "",
                captions: {},
                templateType: '',
                files: this.template.mediaFiles.map(file => ({
                name: file.file.name,
                extension: file.file.name.split('.').pop(),
                data: file.src, 
                user: 'Current User',
                description: file.name || 'Uploaded file'
            }))
            };

            await this.updateEmailTemplateAction(payload);
            loader.close();
            this.success();
        } catch (error) {
            loader.close();
            this.error(error.response ? error.response.data : error.message);
        }
        },
        previewImageSelected(imageSrc) {
        this.selectedImage = imageSrc;
        this.showImageModal = true;
    },
        success() {
            this.$swal({
                title: 'Template Added!',
                text: 'You have successfully added the Template!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$router.push({ name: 'content-templates' });
                }
            })
        },
        error(data) {
            let msg = null;
            if (data)
                msg = this.getErrorString(data);
            this.$swal({
                title: 'Error!',
                //text: msg ?? ' Failed!',
                html: msg ?? " Failed!",
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        getErrorString(data) {
            let msg = null;
            if (data.errors) {
                let errors = data.errors;
                msg = "<div>";
                msg += "<p>Cannot post your request due to the following errors:</p>"
                for (var prop in errors) {
                    if (Object.prototype.hasOwnProperty.call(errors, prop) && prop !== "request") {
                        msg += "<p>";
                        msg += prop.replace("$.", "");
                        msg += ": ";
                        msg += errors[prop].toString().replace("$.", "");
                        msg += "</p>"
                    }
                }
                msg += "</div>";
            }
            else if (data.message) {
                msg = "<div>";
                msg += "<p>Cannot post your request due to the following errors:</p>"
                msg += data.message;
                msg += "</div>";
            }
            return msg;
        },
        async handleFileUpload(event) {
    const files = event.target.files;
    this.template.mediaFiles = []; 
    this.previewImages = []; 

    for (let file of files) {
        const base64String = await this.convertToBase64(file);
        this.template.mediaFiles.push({
            name: file.name,
            src: base64String,
            file
        });
        this.previewImages.push({ name: file.name, src: base64String, file }); 
    }

    console.log("Base64 Encoded Images:", this.template.mediaFiles); 
},

    removeImage(index) {
        this.template.mediaFiles.splice(index, 1);
        const removedFile = this.previewImages.splice(index, 1)[0].file; 

        let dataTransfer = new DataTransfer();
        this.previewImages.forEach((image) => {
            if (image.file !== removedFile) {
                dataTransfer.items.add(image.file);
            }
        });

        this.$refs.fileInput.files = dataTransfer.files;
    },

    convertToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); 
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
    },
    async mounted() {
        this.$nextTick(() => {
    if (this.$refs.quillEditor && this.$refs.quillEditor.quill) {
        this.$refs.quillEditor.quill.enable(false);
    }
});

    try {
        this.$swal.fire({
            title: "Loading Template...",
            text: "Please wait while we fetch the template details.",
            allowOutsideClick: false,
            didOpen: () => {
                this.$swal.showLoading();
            }
        });

        // Fetch the platform types
        const platformData = await this.getPlatformTypeAction();
        if (platformData) {
            this.platformTypes = platformData.map(item => ({
                value: item.id,
                text: item.platform
            }));
        }

        // Fetch template details by ID (if editing)
        if (this.$route.params.id) {
            const response = await this.getContentTemplateByIdAction(this.$route.params.id);
            console.log("Fetched Template Data:", response); // Debugging
            
            // Check if response structure is different (sometimes it's inside .data)
            const result = response ;

            // Ensure `mediaDetails` is properly parsed (since it's stored as a string)
            let parsedMediaDetails = [];
            try {
                parsedMediaDetails = JSON.parse(result.mediaDetails || "[]");
            } catch (e) {
                console.error("Error parsing mediaDetails:", e);
            }

            this.template = {
                name: result.name || "",
                platformType: this.platformTypes.filter(p => result.platformTypeID.includes(p.value)), // Check if value exists in array
                subject: result.subject || "",
                body: result.content || "",
                isActive: true,
                mediaFiles: parsedMediaDetails
            };

            this.previewMedia = parsedMediaDetails
                .filter(file => file.Url) // Ensure we only add valid media
                .map(file => ({
                    name: file.Path.split('/').pop(),
                    src: file.Url,
                    type: file.MediaType // 'photos' or 'videos'
                }));
        }

        this.$swal.close(); // Close loading
    } catch (error) {
        console.error("Error fetching template details:", error);
        this.$swal.fire({
            title: "Error!",
            text: "Failed to load template details. Please try again.",
            icon: "error",
            customClass: { confirmButton: "btn btn-primary" }
        });
    }
}



};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>

<style scoped>
label {
    font-size: 1.714rem !important;
    font-weight: 500;
    margin-bottom: 0;
}
.preview-container {
    margin-top: 20px;
}

/* Styling for preview cards */
.preview-card {
    text-align: center;
    padding: 12px;
    border-radius: 10px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    background: #ffffff;
    transition: transform 0.3s ease-in-out;
}

.preview-card:hover {
    transform: translateY(-15px);
}

/* Improved preview media (images/videos) */
.preview-media {
    width: 80%;
    height: 120px;
    object-fit: cover;
    border-radius: 6px;
    margin-bottom: 8px;
}


.preview-image {
    width: 80px; 
    height: 100px; 
    object-fit: cover;
    border-radius: 5px; 
}

.text-truncate {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.full-image {
    width: 100%;
    max-height: 80vh;
    object-fit: contain;
    display: block;
    margin: auto;
}

</style>